// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-ultimate-guitar {
  transition: fill 0.15s ease;
}
body.light-mode .svg-ultimate-guitar {
  fill: #666;
}
.svg-ultimate-guitar:hover,
.tabs-button:hover .svg-ultimate-guitar,
.guitar-tab-link:hover .svg-ultimate-guitar {
  fill: #ffd706;
}
`, "",{"version":3,"sources":["webpack://./src/svg/SvgUltimateGuitar.less"],"names":[],"mappings":"AAIA;EACC,2BAAA;AAHD;AASA;EACC,UAAA;AAPD;AAUA;;;EAGC,aAAA;AARD","sourcesContent":["// Imported on its own (not through styles/index.less), so it needs the palette\n// directly. A variables-only import emits no CSS.\n@import '../styles/common/colors.less';\n\n.svg-ultimate-guitar {\n\ttransition: fill 0.15s ease;\n}\n\n// In light mode the song-row logo reads as a softer grey instead of solid black.\n// The footer's copy keeps its own (white) colour via a more specific rule, and\n// the hover colour below still wins over this.\nbody.light-mode .svg-ultimate-guitar {\n\tfill: @gray-3;\n}\n\n.svg-ultimate-guitar:hover,\n.tabs-button:hover .svg-ultimate-guitar,\n.guitar-tab-link:hover .svg-ultimate-guitar {\n\tfill: @ULTIMATE-GUITAR;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
